import Link from "next/link";

const Footer = () => {
	return (
		<footer className='py-5 md:py-4 md:flex gap-y-2 gap-x-4 justify-end pr-4 mt-auto'>
			<span className='text-[#414141]'>© 2025 Vetopedia</span>
			<ul className='md:flex gap-y-2 gap-x-4  text-[#3266CC]'>
				<li>
					<Link className={"underline hover:text-black"} href='/datenschutz'>Datenschutz</Link>
				</li>
				<li>
					<a className={"underline hover:text-black"} href='https://v1.vetopedia.org/index.php?title=Impressum'>Impressum</a>
				</li>
				<li>
					<Link className={"underline hover:text-black"} href='/ueber-vetopedia'>Über Vetopedia</Link>
				</li>
			</ul>
		</footer>
	);
};
export { Footer };
